import React from "react";

const FacultyHelpInstructions = () => {
  return (
    <div className="card-wrap" id="studentresource">
      <div className="title">
        <h2>Help</h2>
      </div>
      <div className="row help-wrap">
        <div className="col-lg-3 col-md-3">
          <div className="sidebar" id="sidebar">
            <h2>Table of Contents</h2>
            <a href="#introduction">Introduction</a>
            <a href="#login">Login</a>
            <a href="#dashboard">1. Dashboard</a>
            <a href="#resources">2. Resources</a>
            <a href="#reports">3. Reports</a>
            <a href="#communication">4. Communication</a>
            <a href="#notifications">5. Notifications</a>
            <a href="#feedback">6. Feedback</a>
            <a href="#settings">7. Settings</a>
            <a href="#navbar">8. Navigation Bar</a>
          </div>
        </div>
        <div className="col-lg-9 col-md-3">
          <div className="content">
            <div id="introduction" className="section">
              <h2>Introduction</h2>
              <p>
                This user manual serves as a comprehensive guide to help you
                navigate the Budu Portal with ease. It covers key features,
                step-by-step instructions, and tips to make the most of the
                portal’s capabilities.
              </p>
            </div>

            <div id="login" className="section">
              <h2>Login</h2>
              <p>
                The login page allows Faculty users to securely sign in. Follow
                these steps:
              </p>
              <ol>
                <li>
                  Click the URL:{" "}
                  <a
                    href="https://demo.ui.buduportal.com/login"
                    target="_blank"
                  >
                    https://demo.ui.buduportal.com/login
                  </a>
                </li>
                <li>Enter username and password in the fields provided.</li>
                <li>Click the 'Login' button to access the main dashboard.</li>
              </ol>
              <img src="assets/images/help/login.png" alt="Login" />
            </div>

            <div id="dashboard" className="section">
              <h2>1. Dashboard</h2>

              <h3>1.1 Faculty Resources</h3>
              <ul>
                <li>
                  The Faculty Resource block will display the available faculty
                  resources.
                </li>
                <li>
                  Click on any resource to be redirected to its respective URL.
                </li>
                <li>
                  Click on View All to be redirected to the faculty resources
                  page
                </li>
              </ul>

              <h3>1.2 Faculty Apps</h3>
              <ul>
                <li>
                  The Faculty Apps block will display the available faculty
                  Apps.
                </li>
                <li>
                  Click on any App to be redirected to its respective URL.
                </li>
                <li>
                  Click on View All to be redirected to the faculty resources
                  page
                </li>
              </ul>

              <h3>1.3 Quick Links</h3>
              <ul>
                <li>
                  The Quick Links block displays essential faculty links for
                  easy access.
                </li>
                <li>
                  Click on any quick link to be redirected to its respective
                  URL.{" "}
                </li>
                <li>
                  Click on View All to see the complete list of quick links.
                </li>
              </ul>

              <h3>1.4 Tasks Overview</h3>
              <ul>
                <li>Navigate to task overview section</li>
                <li>
                  Created active tasks are listed under the Tasks Overview
                  section.{" "}
                </li>
                <li>Click on create task button to create new task</li>
                <li>Fill all mandatory fields and click save button</li>
                <li>Click cancel button for cancel the window</li>
                <li>
                  Click ellipse button on each task you can edit and delete the
                  task{" "}
                </li>
                <li>
                  Click View All to navigate to the full list of created tasks.
                </li>
              </ul>

              <h3>1.5 Workload</h3>
              <ul>
                <li>
                  The Workload section displays a pie chart representing the
                  status distribution of active tasks and events.
                </li>
                <li>
                  Each status (e.g., In Progress, Open, On Hold, Due, Completed,
                  Events) is shown in a different color for easy identification.
                </li>
                <li>
                  Click the Zoom In icon to view an expanded version of the pie
                  chart{" "}
                </li>
              </ul>

              <h3>1.6 Calendar</h3>
              <ul>
                <li>
                  By default, current week will be displayed, and current date
                  is highlighted and events for that day will be displayed
                </li>
                <li>
                  A list of scheduled events will appear for the selected day if
                  configured any event
                </li>
                <li>
                  The message "No events scheduled for this day" will appear if
                  there are no events. This indicates that no meetings, tasks,
                  or activities are planned for the selected date.
                </li>
                <li>
                  By clicking on view entire schedule button, will be redirected
                  to the google calendar of the user
                </li>
                <li>By clicking on the arrow can change the week</li>
              </ul>
            </div>

            <div id="resources" className="section">
              <h2>2. Resources</h2>
              <h3>2.1 Faculty Resources</h3>
              <ul>
                <li>Navigate to the faculty Resources page.</li>
                <li>Click on the faculty Resource widget.</li>
                <li>
                  When you click on each widget, the respective details are
                  displayed.
                </li>
                <li>
                  Click on the View Details button to be redirected to a
                  configured url
                </li>
              </ul>

              <h3>2.2 Faculty Apps</h3>
              <ul>
                <li>Navigate to the faculty resource page.</li>
                <li>Click on the faculty app </li>
                <li>
                  When you click on each app, the respective details are
                  displayed.
                </li>
                <li>
                  Click on the View Details button to be redirected to a
                  configured url
                </li>
              </ul>
            </div>

            <div id="reports" className="section">
              <h2>3. Reports</h2>
              <ul>
                <li>
                  The Report Page displays reports grouped by time period: Daily
                  Reports, Weekly Reports and Monthly Reports & Annual Reports
                </li>
                <li>
                  By default, 3 reports are shown under each category block.{" "}
                </li>
                <li>
                  Click View All to see the full list of reports in that
                  category.
                </li>
                <li>
                  Click on any report to be redirected to the University Report
                  Page for full details.
                </li>
              </ul>
            </div>

            <div id="communication" className="section">
              <h2>4. Communication</h2>
              <ul>
                <li>
                  The Communication Page allows faculty to connect with
                  students.
                </li>
                <li>
                  At the top, all terms are displayed (e.g., Fall 2024, Spring
                  2024).
                </li>
                <li>By default, the current term is selected and displayed.</li>
                <li>
                  Clicking on a term shows the list of classes under that term.
                </li>
                <li>
                  Selecting a class displays the list of students enrolled in
                  it, along with: Profile Image, Name, Email ID and Phone Number
                </li>
                <li>
                  Each student entry includes the following icons:
                  <ul>
                    <li>Chat Icon – Opens Microsoft Teams chat</li>
                    <li>
                      Email Icon – Opens the mail compose page and send mail
                    </li>
                    <li>Call Icon – Redirects to Zoom UCaaS</li>
                  </ul>
                </li>
                <li>Broadcast</li>
                <ul>
                  <li>
                    Click the Broadcast button to open the student list of the
                    selected class.
                  </li>
                  <li>Select individual students or use Select All</li>
                  <li>
                    Click “Send mail” to open the mail compose page and send an
                    email to selected students
                  </li>
                </ul>
              </ul>
            </div>

            <div id="notifications" className="section">
              <h2>5. Notifications</h2>
              <ul>
                <li>
                  Notifications are listed with details including:
                  <ul>
                    <li>Category (e.g., Campus Safety, Management)</li>
                    <li>Date (e.g., 29 days ago)</li>
                    <li>Status (e.g., New)</li>
                  </ul>
                </li>
                <li>By default, all notifications will be displayed.</li>
                <li>
                  <p>
                    To filter, click the “Select Notification Type” dropdown and
                    choose a category such as Announcement, Management, Exam
                    Announcement, or Campus Safety. Only notifications of the
                    selected type will be shown.
                  </p>
                </li>
              </ul>
            </div>

            <div id="feedback" className="section">
              <h2>6. Feedback</h2>
              <p>
                The Feedback module allows users to send feedback messages and
                rate their experience with the system. It includes options to
                submit comments, suggestions, and star ratings.
              </p>
              <h3>6.1 Sending Feedback</h3>
              <ul>
                <li>
                  Click on the Feedback Menu and it will be redirected to the
                  Feedback Page
                </li>
                <img src="assets/images/help/feedback.png" alt="Feedback" />
                <li>Subject: Enter Subject</li>
                <li>
                  Message: Type your message or comments in the Message field.
                </li>
                <li>Send: Click the Send button to submit your feedback.</li>
                <li>
                  Cancel: Click the Cancel button to discard your feedback and
                  return to the previous page.
                </li>
              </ul>
              <h3>6.2 Rate Us</h3>
              <ul>
                <li>
                  Rate Us Button : Click on rate us button , a rating popup will
                  appear.
                </li>
                <img src="assets/images/help/rating.png" alt="Rate Us" />
                <li>Select star rating to reflect your experience.</li>
                <li>
                  Provide any additional comments or suggestions in the input
                  field.
                </li>
                <li>
                  Submit : Click the Submit button to record your rating and
                  feedback.
                </li>
                <li>
                  Cancel: Click the Cancel button to discard your feedback
                </li>
              </ul>
            </div>

            <div id="settings" className="section">
              <h2>7. Settings</h2>
              <h3>7.1 Edit Profile</h3>
              <p>
                The Edit Profile option allows users to update their display
                name and profile picture.
              </p>
              <ul>
                <li>Navigate to the Settings Page.</li>
                <li>
                  Edit Profile Button : By clicking a popup will appear for
                  editing profile.
                </li>
                <img
                  src="assets/images/help/editProfile.png"
                  alt="Edit Profile"
                />
                <li>
                  Edit Icon: Click on the current profile image to upload a new
                  one.
                </li>
                <li>
                  Username : Edit the Username field to update your display name
                  on the portal.
                </li>
                <li>Save Changes: Click to Saves updated profile details.</li>
                <li>Close : Closes the popup without saving any changes.</li>
              </ul>
              <h3>7.2 Visibility & Priority Settings of Apps and Widgets</h3>
              <p>
                This section allows users to customize the visibility and
                display order of apps and widgets in their portal.
              </p>
              <ul>
                <li>
                  In the Settings Page, all apps and widgets are listed along
                  with their current visibility and order.
                </li>
                <li>
                  Change Visibility: To hide an app or widget, uncheck the radio
                  button next to its name.
                </li>
                <li>
                  Change Display Order: Rearrange the apps and widgets by
                  dragging and dropping them into the desired order.
                </li>
              </ul>
            </div>

            <div id="navbar" className="section">
              <h2>8. Navigation Bar</h2>
              <ul>
                <li>
                  <p>
                    The BUDU Portal provides an AI-based Search that helps users
                    quickly find information. As you type, the system shows
                    helpful suggestions based on your past searches and
                    available data. If you enter a question, the AI chatbot will
                    open and provide answers. This makes it easy to locate what
                    you need and ensuring a smooth and efficient search
                    experience for all users.
                  </p>
                </li>
                <li>
                  Email: Clicking on the Email Icon will redirect to the Outlook
                  Mail Inbox.
                </li>
                <li>
                  Safety Alert Icon: On click, displays the latest early alerts
                  with details.
                  <ul>
                    <li>
                      Contact Team: Opens the Mail Compose Page pre-filled to
                      contact the safety team.
                    </li>
                    <li>
                      View More: Redirects to the University Campus Safety Alert
                      Page for additional information.
                    </li>
                  </ul>
                </li>
                <li>Notification Icon: Redirects to the Notifications Page.</li>
                <li>Communication Icon: Redirects to the communication Page</li>
                <li>
                  Profile Icon: Once the Logout button is clicked, you will be
                  logged out and redirected to the login page.{" "}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FacultyHelpInstructions;
